import React from 'react';
import { Modal, Button, Dropdown } from 'react-bootstrap';
import './AdminEnterPickModal.css'
import { teams } from '../../utils/teamList';

function AdminEnterPickModal({
    userList,
    showModal,
    setShowModal,
    enterUserPick,
    adminEnterPickUser,
    setAdminEnterPickUser,
    adminEnterPickWeek,
    setAdminEnterPickWeek,
    adminEnterPickTeam,
    setAdminEnterPickTeam
}) {

    const weekList = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18]
    const teamList = teams
    return (
        <>
            <Modal key='user-modal'  show={showModal} onHide={()=>{setShowModal(false);}}>
                    <Modal.Header key='modal-header' closeButton>
                        <Modal.Title key='modal-title'> Enter Pick </Modal.Title>
                    </Modal.Header>
                    <Modal.Body scrollable={true} className='admin-enter-picks-modal-body'>
                        <Dropdown>
                            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                {adminEnterPickUser}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {
                                    userList.map(user => (
                                        <Dropdown.Item onClick={() => {setAdminEnterPickUser(user)}}>{user}</Dropdown.Item>
                                    ))
                                }
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown>
                            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                Week: {adminEnterPickWeek}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {
                                    weekList.map(week => (
                                        <Dropdown.Item onClick={() => {setAdminEnterPickWeek(week)}}>{week}</Dropdown.Item>
                                    ))
                                }
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown>
                            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                Team: {adminEnterPickTeam}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {
                                    teamList.map(team => (
                                        <Dropdown.Item onClick={() => {setAdminEnterPickTeam(team)}}>{team}</Dropdown.Item>
                                    ))
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={()=> {enterUserPick(); setShowModal(false)}}>
                            Enter
                        </Button>
                    </Modal.Footer>
            </Modal>   
        </>       
    );

}

export default AdminEnterPickModal;